module.exports = __webpack_public_path__ + "static/img/032_TO8_1514.fb43ec5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/032_TO8_1514.jpg
// module id = QicI
// module chunks = 0